<div class="bootstrap-container">
  <div class="container-fluid container-custom d-flex align-items-center">
    <div class="container">
      <div class="row text-center">
        <div class="col-12 my-4">
          <img src="assets/img/butterfly-logo.png" class="img-fluid mx-auto mb-3" alt="">
        </div>
        <div class="col-12 text-white">
          <p class="p-custom">Take better, faster, safer decisions</p>
        </div>
      </div>

      <!-- Spinner mostrato durante il caricamento dei dati -->
      @if (!loginError && !loadingError && loadingValue < loadingMaxValue) {
        <div class="row d-flex justify-content-center">
          <div class="col-12 mt-5 text-center">
            <div class="spinner"></div>
            <div class="loading-text">Caricamento dati in corso...</div>
          </div>
        </div>
      }

      <!-- Bottone login in caso di errore di autenticazione -->
      @if (loginError) {
        <div class="row d-flex justify-content-center">
          <div class="col-12 mt-5 text-center">
            <button class="btn-custom rounded px-5 py-2" (click)="login()">{{'generic.buttons.login' | translate}}</button>
          </div>
        </div>
      }

      <!-- Messaggio di errore generico -->
      @if (loadingError && !loginError) {
        <div class="row d-flex justify-content-center">
          <div class="col-12 mt-5 text-center">
            <div class="error-text">Si è verificato un errore durante il caricamento</div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
